var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":"","color":"secondary","loading":_vm.loading},on:{"click":_vm.submit}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-sync")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }